import './style.scss';
import React, { Suspense } from 'react';
import earkickBear from '../../../resources/images/dashboard/earkick-bear-heart.svg';
import appStoreDownload from '../../../resources/images/app-store.webp';
import googlePlayDownload from '../../../resources/images/google-play-badge.png';

const androidDownload = false;

const TryEarkick = ({ language = 'en' }) => {
  return (
    <Suspense fallback={<div>{language === 'de' ? 'Laden...' : 'Loading...'}</div>}>
      <div className="try-earkick">
        <div className="try-earkick__container">
          <div className="circle-earkick">
            <img
              className="earkick-bear"
              src={earkickBear}
              alt="Earkick bear"
              loading="lazy"
            />
          </div>
          {language === 'en' &&
            <h2>Try Earkick today!</h2>
          }
          {language === 'de' &&
            <h2>Probier Earkick noch heute aus!</h2>
          }
          {language === 'en' &&
            <p>Track and improve your mental health in real time</p>
          }
          {language === 'de' &&
            <p>Erfasse und stärke deine mentale Gesundheit in Echtzeit.</p>
          }
          <div className="download-apps">
            <a
              href="https://apps.apple.com/us/app/id1584854531"
              target="_blank"
              className="app-store" 
              rel="noreferrer"
            >
              <img
                src={appStoreDownload}
                alt="Appstore download button"
                loading="lazy"
              />
            </a>
            {androidDownload && 
              <a
                className="google-play" 
                href='https://play.google.com/store/apps/details?id=com.earkick.SelfCareCompanion&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                <img alt='Get it on Google Play' src={googlePlayDownload} />
              </a>
              }
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default TryEarkick;
